module.exports = __webpack_public_path__ + "img/bemestar.32172c5d.svg";